import { getBusinessPartners, getSchoolsPartners } from '@webapps/business';
import { useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useEffect } from 'react';

import Content from './Components/Content';

const Cvtheque = () => {
  const { idUser, profile, checkPermissions, isPremium } = useAuth();

  useEffect(() => {
    if (isPremium !== null) {
      checkPermissions();
    }
  }, [isPremium]);

  const {
    data: { content: partnersSchool = [] } = {},
    isLoading: isLoadingGetMyBusiness,
  } = useQuery(getSchoolsPartners, {
    key: ['schoolsPartners', idUser],
    variables: {
      id: idUser,
      type: 'accepted',
      page: 0,
      size: 2000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    data: { content: partnersBusiness = [] } = {},
    isLoading: isLoadingGetMySchools,
  } = useQuery(getBusinessPartners, {
    key: ['businessPartners', idUser],
    variables: {
      id: idUser,
      type: 'accepted',
      page: 0,
      size: 2000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  if (!isPremium) {
    return <div></div>;
  }

  return (
    !isLoadingGetMyBusiness &&
    !isLoadingGetMySchools && (
      <div style={{ overflow: 'hidden' }}>
        <Content
          partnersList={
            profile === 'SCHOOL'
              ? partnersSchool?.map(({ id }) => id).join()
              : partnersBusiness?.map(({ id }) => id).join()
          }
        />
      </div>
    )
  );
};

export default Cvtheque;
